import {
  ParsedCustomDimensions,
  RouteOptions,
  SetCustomDimensionsArgs,
  ThirdPartyTrackingAgent,
  ThirdPartyTrackingAgentArgs,
} from './types';
import { createConfigParametersRepository } from '../../configParametersRepository';
import { checkThirdPartyTrackingStorageInit } from '../../configParametersRepository/storageClient/storage';
import { trackEvent } from './events';
import { trackGA4Promo } from './promotions';
import { trackQualtrics } from './surveys';
import trackWebVitals from './webVitals';
import { fireEvent } from '../tag-commander/datalayer';
import { Datalayer } from '../tag-commander/types';

const parseSetCustomDimensionArgs = (
  args: SetCustomDimensionsArgs | [ParsedCustomDimensions]
): ParsedCustomDimensions => {
  if (typeof args[0] === 'number' || typeof args[0] === 'string') {
    return {
      dimension: args[0],
      value: args[1],
    };
  }
  return args[0];
};

export const routeOptions: RouteOptions = {
  pageMap: {},
  matcher: {
    getPathParams: () => ({}),
    findMatchingPattern: () => undefined,
  },
};

export const createThirdPartyTrackingAgent = ({
  trackSurvey,
  trackPage,
  routePageMap,
  routeMatcher,
}: ThirdPartyTrackingAgentArgs): ThirdPartyTrackingAgent => {
  routeOptions.matcher = routeMatcher;
  routeOptions.pageMap = routePageMap;

  const setCustomDimension = async (...args: SetCustomDimensionsArgs) => {
    checkThirdPartyTrackingStorageInit();
    if (typeof window === 'undefined') return;
    const { getTrackingStorageClient } = createConfigParametersRepository();
    const storageClient = getTrackingStorageClient();
    const { dimension, value } = parseSetCustomDimensionArgs(args);
    storageClient?.updateCustomParamsAndDimensions({
      [`dimension${dimension}`]: value,
    });
  };

  return {
    trackQualtrics,
    trackSurvey,
    trackFireEvent: (
      category: string,
      key?: keyof Datalayer,
      value?: Datalayer[keyof Datalayer]
    ) => {
      fireEvent({ event_category: category, [key]: value });
    },
    trackPage: trackPage,
    setCustomDimension,
    trackEvent,
    trackPromotion: trackGA4Promo,
    trackWebVitals,
  };
};
